<script lang="ts">
import { defineComponent, PropType, computed } from 'vue'

import { DateTime } from 'luxon'

import { UtcOffsetDisplay } from '../util'

import { Artist, Store } from '../types'

export default defineComponent({
  name: 'ArtistListItem',
  props: {
    timezone: {
      type: String,
      default: '',
    },
    emitter: {
      type: Object,
      required: true,
    },
    store: {
      type: Object as PropType<Store>,
      required: true,
    },
    artist: {
      type: Object as PropType<Artist>,
      required: true,
    },
  },
  setup(props) {
    const availableFromTime = computed(() => {
      const dt = DateTime.fromISO(props.artist.available[0].from, { zone: 'UTC' })
      const redt = dt.setZone(props.timezone)
      return redt.toFormat('HH:mm')
    })

    const availableToTime = computed(() => {
      const dt = DateTime.fromISO(props.artist.available[0].to, { zone: 'UTC' })
      const redt = dt.setZone(props.timezone)
      return redt.toFormat('HH:mm')
    })

    return {
      props,
      UtcOffsetDisplay,
      availableFromTime,
      availableToTime,
    }
  },
})
</script>

<template>
  <div class="content py-2 px-3">
    <div class="flex flex-row mt-1 items-center">
      <div class="w-16 mr-1">
        <img :src="artist.photoUrl" class="w-10 h-10 rounded-full" />
      </div>
      <div class="w-full text-slipmat-600">
        <div class="text-slipmat-600">
          <i class="fas fa-headphones mr-1"></i> {{ props.artist.name }}
        </div>
        <div class="text-gray-500 text-sm leading-tight">
          {{ props.artist.timezone }} ({{ UtcOffsetDisplay(props.artist.utcOffset) }})
        </div>
      </div>
    </div>
    <div class="mt-3 pt-2 border-t border-gray-200 text-gray-500">
      <div class="mt-1">
        <i class="far fa-clock mr-1"></i> Available {{ availableFromTime }} &ndash;
        {{ availableToTime }}
      </div>
      <div class="mt-1">
        <i class="far fa-tags pr-1"></i>
        <span v-for="(tag, index) in artist.tags" :key="index"
          >{{ tag }}<span v-if="index < artist.tags.length - 1">, </span>
        </span>
      </div>
    </div>
  </div>
</template>
